<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link
                    :to="{ name: 'transaction.index' }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Detail Transaksi</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" class="pb-2" v-if="loadingApp == false">
            <div
                class="section detail-transaction-section pt-4"
                style="--height:150px;"
            >
                <div class="detail-card">
                    <div class="listed-detail mt-1">
                        <div class="icon-wrapper">
                            <div class="iconbox bg-success">
                                <ion-icon name="checkmark-outline"></ion-icon>
                            </div>
                        </div>
                        <h2 class="text-center mt-2 mb-1">
                            Transfer Saldo
                        </h2>
                        <h3 class="text-center">
                            {{ transaction.to_customer.phone }}
                        </h3>
                    </div>
                    <div class="listed-detail mt-1">
                        <dd class="mb-0">
                            ID Transkasi <b>#{{ transaction.id }}</b>
                        </dd>
                        <dd class="mb-0">
                            Status Transkasi<br />
                            <div class="chip chip-success">
                                <span class="chip-label">Berhasil</span>
                            </div>
                        </dd>
                        <dd class="mb-0">
                            <small>Tanggal {{ transaction.created_at }}</small>
                        </dd>
                    </div>
                    <div class="listed-detail mt-1 mb-2">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <h5 class="mb-0 ml-1">
                                Detail Transaksi
                            </h5>
                        </blockquote>
                        <table>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Nominal
                                </td>
                                <td width="20px">:</td>
                                <td>
                                    <b>Rp {{ transaction.nominal | rupiah }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    ID Penerima
                                </td>
                                <td width="20px">:</td>
                                <td>QF{{ transaction.to_customer_id }}</td>
                            </tr>
                            <tr>
                                <td class="text-nowrap" width="130px">
                                    Nama Penerima
                                </td>
                                <td width="20px">:</td>
                                <td>{{ transaction.to_customer.name }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="listed-detail" style="border-bottom:0px;">
                        <a
                            :href="
                                'https://play.google.com/store/apps/details?id=' +
                                    VUE_ENV.VUE_APP_PACKAGENAME_APK
                            "
                            target="_blank"
                            class="btn btn-dark btn-block"
                        >
                            <ion-icon name="logo-google-playstore"></ion-icon>
                            Beri Rating
                        </a>
                        <a
                            :href="
                                'https://api.whatsapp.com/send?text=' + message
                            "
                            target="_blank"
                            class="btn btn-success btn-block"
                        >
                            <ion-icon name="logo-whatsapp"></ion-icon> Kirim
                            Laporan Transkasi
                        </a>
                        <!-- <button
                            class="btn btn-primary btn-block"
                            @click="print()"
                        >
                            <ion-icon name="print"></ion-icon> Print Struk
                        </button>
                        <button
                            class="btn btn-primary btn-block"
                            @click="coming()"
                        >
                            <ion-icon name="cloud-download"></ion-icon> Download
                            Struk
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $axios from './../../../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                sender: [],
                transaction: {},
                loadingApp: true,
                loadingButton: false,
                message: '',
            };
        },
        created() {
            this.getDetail(this.$route.params.id);
        },
        computed: {
            ...mapState(['errors', 'toast', 'VUE_ENV']),
        },
        methods: {
            ...mapActions(['coming']),
            getDetail(id) {
                $axios
                    .get('/transaction/transfer/' + id)
                    .then(response => {
                        this.transaction = response.data.data;
                        this.loadingApp = false;
                        this.message = encodeURIComponent(
                            'Saya telah berhasil melakukan transfer saldo ke ' +
                                this.transaction.to_customer.phone +
                                ' a.n ' +
                                this.transaction.to_customer.name +
                                ' sebesar Rp ' +
                                this.$options.filters.inputRupiah(
                                    this.transaction.nominal
                                ) +
                                '\n' +
                                'Penambahan saldo dapat dicek pada menu mutasi saldo. Terima kasih atas kepercayaannya.'
                        );
                        console.log(this.message);
                    })
                    .catch(() => {
                        this.loadingApp = false;
                    });
            },
            print() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.print();
                }
            },
        },
        destroyed() {
            this.$store.commit('CLEAR_ERRORS');
        },
        filters: {
            inputRupiah: function(value) {
                value = value.toString();
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
